module.exports = __webpack_public_path__ + "07e837d72749a30212dc82fdb5abf87e.svg";